var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTether(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.666504,
    width: 32,
    height: 32,
    rx: 12,
    fill: "#50AF95",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.4246 16.5241C18.3451 16.5306 17.9341 16.5572 17.0173 16.5572C16.2881 16.5572 15.7703 16.5335 15.5887 16.5241C12.7707 16.3895 10.6672 15.857 10.6672 15.2193C10.6672 14.5817 12.7707 14.0498 15.5887 13.9131V15.9937C15.773 16.0081 16.3006 16.0419 17.0298 16.0419C17.9049 16.0419 18.3431 16.0023 18.422 15.9944V13.9145C21.234 14.0505 23.3328 14.5831 23.3328 15.2193C23.3328 15.8555 21.2347 16.3881 18.422 16.5234L18.4246 16.5241ZM18.4243 13.701V11.8392H22.3487V9H11.6639V11.8392H15.5877V13.7003C12.3984 13.8593 10 14.5452 10 15.367C10 16.1889 12.3984 16.8741 15.5877 17.0338V23H18.4236V17.0317C21.6056 16.8726 24 16.1875 24 15.3663C24 14.5452 21.6076 13.86 18.4236 13.7003L18.4243 13.701Z",
    fill: "#50AF95"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTether);
export default __webpack_public_path__ + "static/media/tether.636ad070d97eecc76e365e4098f9246c.svg";
export { ForwardRef as ReactComponent };